import { cva } from '@/styled-system/css';

export const labeledInputRecipe = cva({
  base: {
    'display': 'inline-block',
    'position': 'relative',
    'width': '100%',

    // Input styles
    '& > [data-c11n-component="Input"]': {
      'paddingBlockStart': 'loose',
      'paddingBlockEnd': 'tighter',

      '&::placeholder': {
        transition: {
          _motionReduce: 'none',
          _motionSafe: '{color 0.15s ease}',
        },
      },

      '&:not(:focus)::placeholder': {
        color: 'transparent.invisible',
      },
    },

    // Label styles
    '& > [data-c11n-component="Label"]': {
      'textStyle': 'body',
      'position': 'absolute',
      'insetInlineStart': 'default',
      'transform': 'translateY({spacing.default})',
      'transformOrigin': '0 0',
      'pointerEvents': 'none',
      'truncate': true,
      'maxWidth': 'calc(100% - {spacing.default})',

      '&:has(+ [data-c11n-component="Input"]:focus), &:has(+ [data-c11n-component="Input"]:not(:placeholder-shown)), &:has(+ [data-c11n-component="Input"]:-webkit-autofill), &:has(+ [data-c11n-component="Input"]:read-only)':
        {
          textStyle: 'body-xs-bold',
          transform: 'translateY({spacing.tighter})',
        },

      'transition': {
        _motionReduce: 'none',
        _motionSafe: '{all 0.15s ease}',
      },
    },
  },
  variants: {
    fluid: {
      true: {},
      false: {
        width: 'auto',
      },
    },
    readOnly: {
      true: {
        '& > [data-c11n-component="Label"]': {
          insetInlineStart: 'none',
        },
      },
      false: {},
    },
  },
});
